import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import {
    ButtonController,
    IButtonControllerOptions,
} from '../../../../Common/ButtonController';
import { AnimationContents } from '../../../../../AnimationContents';
import { AppStateEnum, GameModel } from '../../../../Models/Game/GameModel';
import { GameLogic } from '../../../../Logic/GameLogic';

export class LeaderboardController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super('LeaderboardController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.RATING_SCREEN_JSON,
            libraryName: 'main',
            childControllers: {
                closeButton: {
                    instanceName: 'window.container.btn_close',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlay('window close');
                            this.$queue.get('hide').addToQueue();
                        },
                    },
                },
            },
            queue: {
                hide: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        if (this.$model.appState === AppStateEnum.game) {
                            this._gameLogic.showGameEnd();
                        } else {
                            this._gameLogic.resetMenu();
                        }
                    },
                },
            },
        };
    }

    protected async onInitialize(): Promise<void> {
        this.gotoAndPlay('window initialization');

        for (let i = 0; i < 8; i++) {
            this.setTextByQuery(`window.container.content.num${i}`, ``);
            this.setTextByQuery(`window.container.content.count${i}`, ``);
            this.setTextByQuery(`window.container.content.player${i}`, ``);
        }

        this.setScaleByQuery(`window.container.content.currentPlace`, 0, 0);
        this.setTextByQuery(`window.container.content.currentPlace.num`, '');
        this.setTextByQuery(`window.container.content.currentPlace.count`, '');
        this.setTextByQuery(`window.container.content.currentPlace.player`, '');

        const count = 8;
        const users = await this._gameLogic.getLeaderboards();

        for (let i = 0; i < 8; i++) {
            const data = i < users.length ? users[i] : null;

            if (data) {
                this.setTextByQuery(
                    `window.container.content.num${i}`,
                    `${i + 1}`
                );
                this.setTextByQuery(
                    `window.container.content.count${i}`,
                    data.score.toString()
                );
                this.setTextByQuery(
                    `window.container.content.player${i}`,
                    data.name
                );
            } else {
                this.setTextByQuery(`window.container.content.num${i}`, ``);
                this.setTextByQuery(`window.container.content.count${i}`, ``);
                this.setTextByQuery(`window.container.content.player${i}`, ``);
            }
        }

        if (this.$model.player.name !== '') {
            const place =
                users.indexOf(users.find(o => o.id === this.$model.player.id)) + 1;

            this.setTextByQuery(`window.container.content.currentPlace.num`, `${place}`);
            this.setTextByQuery(
                `window.container.content.currentPlace.count`,
                `${this.$model.player.totalScore}`
            );
            this.setTextByQuery(
                `window.container.content.currentPlace.player`,
                `${this.$model.player.name}`
            );
            this.setScaleByQuery(`window.container.content.currentPlace`, 1, 1);
        }
    }

    protected onLandscape(): void {
        this.display.scale.set(1.1);
        this.display.y = 20;
    }
}
